module.exports = __webpack_public_path__ + "static/media/woman-home.1050eb5c.png";